module.exports = __webpack_public_path__ + "static/media/icone-erro.b557ee18.svg";